import { put, select, takeEvery } from 'redux-saga/effects';

import * as ReserveActions from './actions';

const fetchAllState = state => state;
const fetchRouterState = state => state.router;

function * notifyTransactionSent (action) {
  const routerState = yield select(fetchRouterState);

  if (routerState.location.pathname !== "/signup")
    yield put({
      type: ReserveActions.TX_BROADCAST_RECEIVED
    });
}

function * notifyTransactionChanged (action) {
  const routerState = yield select(fetchRouterState);

  if (routerState.location.pathname === "/reserve") {
    const allState = yield select(fetchAllState);
    const confirmedQueue = allState.reserve.confirmedQueue;
    //const matching = "/^TEMP_/";
    let txCount = 0;

    for (let i = 0; i < confirmedQueue.length; i++)
      if (allState.transactions[allState.transactionStack[confirmedQueue[i].stackId]].status === 'pending')
        //|| allState.transactionStack[confirmedQueue[i]].match(matching))
        txCount++;

    yield put({
      type: ReserveActions.RESERVE_CHANGE_NONCE,
      txCount: txCount
    });
  }
}

function * notifyContractSynced (action) {
  const routerState = yield select(fetchRouterState);

  if (routerState.location.pathname !== "/signup")
    yield put({
      type: ReserveActions.CONTRACT_SYNC_RECEIVED,
      pathnameAtSynced: routerState.location.pathname
    });
}

function * notifyTransactionSuccessful (action) {
  const allState = yield select(fetchAllState);
  const confirmedQueue = allState.reserve.confirmedQueue;

  for (let i = 0; i < confirmedQueue.length; i++)
    if (allState.transactions[allState.transactionStack[confirmedQueue[i].stackId]].status === 'pending')
      return;

  if (allState.router.location.pathname !== "/signup")
    yield put({
      type: ReserveActions.RESERVE_COMPLETED
    });
}

function * examineBlock (action) {
  const allState = yield select(fetchAllState);

  if (allState.router.location.pathname !== "/signup" && allState.currentBlock.hash === action.blockHeader.parentHash)
    yield put({
      type: ReserveActions.RESERVE_BLOCK_RECEIVED
    });
}

function * reserveSaga () {
  yield takeEvery(ReserveActions.TX_BROADCASTED, notifyTransactionSent);
  yield takeEvery(ReserveActions.TX_SUCCESSFUL, notifyTransactionSuccessful);
  yield takeEvery(ReserveActions.CONTRACT_SYNCED, notifyContractSynced);
  yield takeEvery(ReserveActions.BLOCK_RECEIVED, examineBlock);
  yield takeEvery(ReserveActions.RESERVE_ADDED, notifyTransactionChanged);
}

export default reserveSaga;
